import { PayloadAction } from "@reduxjs/toolkit";
import { getTimeOffs_timeOffs_timeOffs } from "../../../../__generated/getTimeOffs";
import { PayrunState } from "../payrunSlice";

const selectedLeaveSetted = (
  state: PayrunState,
  { payload }: PayloadAction<getTimeOffs_timeOffs_timeOffs>
) => {
  state.leaves.selectedLeave = payload;
};

export default selectedLeaveSetted;
